import React, { useState, useCallback, ReactElement, useEffect } from 'react';
import { Button } from '@framework-controls/core';
import { JSXIf } from '@framework-controls/jsxconditions';
import { IconDashMenu, IconProfile, IconRDropDownArrow } from 'src/content/icons';
import css from './MenuCustAcct.module.scss';
import classNames from 'classnames';
import { strings } from 'src/localization';
import { ApptCust, ApptVeh, PhotoList, SpecData, VehicleRec, VehicleStockPhoto, ascCtaInteractionInput, ascMenuInteractionInput } from 'src/models';
import { ComponentMapIds } from '../map';
import { IView } from 'Framework';
import DesiredVehNotAvailImg from 'src/content/images/Desired_VehNotAvail.jpg';
import VehicleModelImages from '../VehicleImages/VehicleModelImages';
import Logo from '../Logo/Logo';
import MenuBackBtn from '../Menu/MenuBackBtn/MenuBackBtn';
import { CustMode, Vehicles } from 'src/enums';
import { ascCtaInteraction, ascMenuInteraction } from 'src/helpers/EventHelper/EventHelper';

interface IProps {
    back: () => void;
    specData?: SpecData;
    apptCust?: ApptCust;
    apptVeh?: ApptVeh;
    mainPaneViewOrder?: IView[];
    vehicles: VehicleRec[];
    selectedVehicle: string;
    vehiclePhoto: VehicleStockPhoto;
    vehPhotoList: PhotoList;
    theme: string;
    employeeFlag?: boolean;
    Itype: string | undefined;
    clearMainPanes: () => void;
    pushToMainPanes: (inputView: IView) => void;
    popFromMainPane: (id: string) => void;
    setCustMode: (custMode: CustMode) => void;
    viewVehicles: (inp: Vehicles) => void;
    clearMaintContracts: () => void;
}

const MenuCustAcct = (props: IProps) => {
    const [menuOpenFlag, setMenuOpenFlag] = useState<boolean>(false);
    const [profileOpenFlag, setProfileOpenFlag] = useState<boolean>(false);
    const [vehicleOpenFlag, setVehicleOpenFlag] = useState<boolean>(false);
    const [currentSelectVeh, setCurrentSelectVeh] = useState<string>(props.selectedVehicle);
    const [vehicleImg, setVehicleImg] = useState<any>('');
    const [hideMenuBtn, setHideMenuBtn] = useState<boolean>(false);
    const [hideProfile, setHideProfile] = useState<boolean>(false);
    const [hideVehicle, setHideVehicle] = useState<boolean>(false);
    const mainViewPanes = props.mainPaneViewOrder ?
        props.mainPaneViewOrder.map((view): IView => ({ ...view })) : [];
    const currentViewPanes = mainViewPanes[mainViewPanes.length - 1];

    const dealerNameClassName = classNames(
        css.dealerName,
        {
            [css.dealerNameCadillac]: props.theme === 'cadillac',
            [css.dealerNameHonda]: props.theme === 'honda',
            [css.dealerNameBuick]: props.theme === 'buick',
        },
    );

    const dealerName = props.specData?.mobileName;

    const dealerNameLitClassName = classNames(
        css.dealerNameLit,
        {
            [css.dealerNameLitSmallFontSize]: dealerName && dealerName.length > 18,
        },
    );

    const dealerNameArea = <h1 className={dealerNameLitClassName}>{dealerName}</h1>;

    useEffect(() => {
        if (currentViewPanes && currentViewPanes.viewId === ComponentMapIds.ResetPassword) {
            setProfileOpenFlag(false);
            setVehicleOpenFlag(false);
            setMenuOpenFlag(false);
            setHideMenuBtn(true);
            setHideProfile(true);
            setHideVehicle(true);
        } else {
            setHideMenuBtn(false);
            setHideProfile(false);
            setHideVehicle(false);
        }
    }, [currentViewPanes, profileOpenFlag, menuOpenFlag, vehicleOpenFlag]);

    useEffect(() => {
        if (props.selectedVehicle !== currentSelectVeh) {
            setVehicleImg('');
            setCurrentSelectVeh(props.selectedVehicle);
        }
    }, [props.selectedVehicle, currentSelectVeh, vehicleImg]);

    // When the menu button is pressed, switch the open flag.
    // By CPM, this should open a flyout with the UserAcctMenu links.
    // Currently I am sending the user to the UserAcctMenu base screen.
    // Do not use clear main panes followed by a push as it causes issues with logging out and in
    const menuOpenHandler = useCallback(() => {
        setProfileOpenFlag(false);
        setVehicleOpenFlag(false);
        props.clearMainPanes();
        props.pushToMainPanes({
            viewId: ComponentMapIds.UserAccountMenu,
            component: ComponentMapIds.UserAccountMenu,
        });
        const ascMenuInteractionInp : ascMenuInteractionInput = {
            pageType: 'service',
            elementText: strings.Menu,
            elementSubtype: 'hamburger_menu',
            elementType: 'menu',
            eventAction: 'click',
        };
        ascMenuInteraction(ascMenuInteractionInp);
        // const panes: IView[] = mainViewPanes;
        // let pane: IView = mainViewPanes[mainViewPanes.length - 1];
        // const paneLength: number = mainViewPanes.length;
        // let paneNum: number = 1;
        // while (pane.viewId !== ComponentMapIds.UserAccountMenu) {
        //     props.popFromMainPane(panes[paneLength - paneNum].viewId);
        //     paneNum++;
        //     if (paneLength - paneNum < 0) {
        //         props.pushToMainPanes({
        //             viewId: ComponentMapIds.UserAccountMenu,
        //             component: ComponentMapIds.UserAccountMenu,
        //         });
        //         break;
        //     }
        //     pane = panes[paneLength - paneNum];
        // }
    }, [props.clearMainPanes, props.pushToMainPanes]);
    //  If profile is not open and the current screen displayed is ViewAccount
    //  change the profile menu to open.
    if (!profileOpenFlag) {
        if (currentViewPanes && currentViewPanes.viewId === ComponentMapIds.ViewAccount) {
            setMenuOpenFlag(false);
            setProfileOpenFlag(true);
            setVehicleOpenFlag(false);
            props.popFromMainPane(ComponentMapIds.VehSel);
        }
    }
    //  If profile not open and the current screen displayed is not ViewAccount
    //  change the profile menu to closed.
    if (profileOpenFlag) {
        if (currentViewPanes && currentViewPanes.viewId !== ComponentMapIds.ViewAccount) {
            setProfileOpenFlag(false);
        }
    }
    const profileOpenHandler = useCallback((e:any) => {
        setMenuOpenFlag(false);
        setProfileOpenFlag(!profileOpenFlag);
        setVehicleOpenFlag(false);
        if (!profileOpenFlag) {
            props.pushToMainPanes({
                viewId: ComponentMapIds.ViewAccount,
                component: ComponentMapIds.ViewAccount,
            });
            props.popFromMainPane(ComponentMapIds.VehSel);
        } else {
            props.popFromMainPane(currentViewPanes.viewId);
        }
        const ascMenuInteractionInp : ascMenuInteractionInput = {
            pageType: 'service',
            elementText: strings.Profile,
            elementSubtype: 'cta_icon',
            elementType: 'menu',
            eventAction: 'click',
        };
        ascMenuInteraction(ascMenuInteractionInp);
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: strings.Profile,
            elementColor: '',
            elementOrder: '',
            elementType: 'menu',
            elementSubType: 'other_buttons',
            eventAction: 'click',
            eventActionResult: !profileOpenFlag ? 'open' : 'close',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    }, [profileOpenFlag, props.vehicles, props.selectedVehicle, props.pushToMainPanes, props.popFromMainPane,
        currentViewPanes.viewId]);

    //  If vehicle is not open and the current screen displayed is VehSel
    //  change the vehicle menu to open.
    if (!vehicleOpenFlag) {
        if (currentViewPanes && currentViewPanes.viewId === ComponentMapIds.VehSel) {
            setMenuOpenFlag(false);
            setProfileOpenFlag(false);
            setVehicleOpenFlag(true);
            props.popFromMainPane(ComponentMapIds.ViewAccount);
        }
    }
    //  If vehicle not open and the current screen displayed is not VehSel
    //  change the vehicle menu to closed.
    if (vehicleOpenFlag) {
        if (currentViewPanes && currentViewPanes.viewId !== ComponentMapIds.VehSel) {
            setVehicleOpenFlag(false);
        }
    }

    const vehicleOpenHandler = useCallback((e:any) => {
        setMenuOpenFlag(false);
        setProfileOpenFlag(false);
        setVehicleOpenFlag(!vehicleOpenFlag);
        props.clearMaintContracts();
        props.viewVehicles(Vehicles.NAM);
        props.setCustMode(CustMode.ViewVeh);
        if (!vehicleOpenFlag) {
            props.pushToMainPanes({
                viewId: ComponentMapIds.VehSel,
                component: ComponentMapIds.VehSel,
            });
            props.popFromMainPane(ComponentMapIds.ViewAccount);
        } else {
            props.popFromMainPane(currentViewPanes.viewId);
        }
        const ascMenuInteractionInp : ascMenuInteractionInput = {
            pageType: 'service',
            elementText: strings.SelectYourVeh,
            elementSubtype: 'dropdown',
            elementType: 'menu',
            eventAction: 'click',
        };
        ascMenuInteraction(ascMenuInteractionInp);
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: strings.SelectYourVeh,
            elementColor: '',
            elementOrder: '',
            elementType: 'menu',
            elementSubType: 'other_buttons',
            eventAction: 'click',
            eventActionResult: !vehicleOpenFlag ? 'open' : 'close',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    }, [vehicleOpenFlag, props.clearMaintContracts, props.viewVehicles, props.setCustMode, props.vehicles,
        props.selectedVehicle, props.pushToMainPanes, props.popFromMainPane, currentViewPanes.viewId]);

    const showProfile = props?.apptCust && props.apptCust.custFirstName !== '' ? true : false;

    // The menu button has a different look while the menu is open.
    // Therefore, toggle the css being used based on if the menu is open.
    const menuClassName = classNames(
        css.menuToggle,
        {
            [css.menuToggleCheck]: menuOpenFlag,
        },
    );
    const profileClassName = classNames(
        css.menuProfileToggle,
        {
            [css.menuProfileToggleCheck]: profileOpenFlag,
            [css.menuProfileToggleCadillac]: props.theme === 'cadillac',
            [css.menuProfileToggleHonda]: props.theme === 'honda',
        },
    );


    let vehClassName = classNames(
        css.menuVehToggle,
        {
            [css.menuVehToggleCheck]: vehicleOpenFlag,
            [css.menuVehToggleCheckSPM]: (props.theme === 'toyotaSPM') && vehicleOpenFlag,
            [css.menuVehToggleHonda]: props.theme === 'honda',
            [css.menuVehToggleBuick]: props.theme === 'buick',
            [css.menuVehToggleGMC]: props.theme === 'gmc',
        },
    );
    if (props.theme === 'colorSensitive') {
        vehClassName = classNames(
            css.menuVehToggleCS,
            {
                [css.menuVehToggleCheckCS]: vehicleOpenFlag,
            },
        );
    }
    const vehIconClassName = classNames(
        css.vehIconActive,
        {
            [css.vehIconRotate]: vehicleOpenFlag,
        },
    );

    const vehLit = classNames(
        css.vehLit,
        {
            [css.vehLitMini]: props.theme === 'mini',
            [css.vehLitBuick]: props.theme === 'buick',
            [css.vehLitBMW]: props.theme === 'bmw',
        },
    );

    const logoArea = classNames(
        css.logoArea,
        {
            [css.logoUnsetWidth]: props.theme === 'mazda' || props.theme === 'jaguar',
        },
    );

    const menuBtnContentsStyles = classNames(
        css.menuBtnContents,
        {
            [css.menuBtnContentsHonda]: props.theme === 'honda',
            [css.menuBtnContentsBuick]: props.theme === 'buick',
            [css.menuBtnContentsFord]: props.theme === 'ford',

        },
    );

    const menuBtnContentsStyles2 = classNames(
        css.menuBtnContents2,
        {
            [css.menuBtnContentsHonda]: props.theme === 'honda',
            [css.menuBtnContentsBuick]: props.theme === 'buick',
            [css.menuBtnContentsFord]: props.theme === 'ford',

        },
    );

    const menuBtnContentsStyles3 = classNames(
        css.menuBtnContents3,
        {
            [css.menuBtnContentsHonda]: props.theme === 'honda',
            [css.menuBtnContentsBuick]: props.theme === 'buick',
            [css.menuBtnContentsFord]: props.theme === 'ford',

        },
    );

    let vehicleInfoArea: ReactElement | null = null;
    vehicleInfoArea =
        <div id='vehicle' className={menuBtnContentsStyles3}>
            <div className={vehLit}>
                {strings.SelectYourVeh}
            </div>
        </div>;
    const vehArray = props.vehicles[props.selectedVehicle];

    if (vehArray) {
        let vehImgCss = css.vehicleImg;
        if (!vehicleImg) {
            setVehicleImg(DesiredVehNotAvailImg);
            vehImgCss = css.vehicleImgDefault;
        }
        let yearStyleVin = '';
        if (vehArray.year) {
            yearStyleVin = yearStyleVin + vehArray.year;
        }
        if (vehArray.style) {
            if (vehArray.year) {
                yearStyleVin = yearStyleVin + ' | ' + vehArray.style;
            } else {
                yearStyleVin = yearStyleVin + vehArray.style;
            }
        }
        if (vehArray.vin) {
            if (vehArray.year || vehArray.style) {
                yearStyleVin = yearStyleVin + ' | ' + vehArray.vin;
            } else {
                yearStyleVin = yearStyleVin + vehArray.vin;
            }
        }
        const makeDiv = classNames(
            css.makeDiv,
            {
                [css.vehLitMini]: props.theme === 'mini',
                [css.makeDivHonda]: props.theme === 'honda',
                [css.makeDivBMW]: props.theme === 'bmw',


            },
        );
        const yearDiv = classNames(
            css.yearDiv,
            {
                [css.vehLitMini]: props.theme === 'mini',
            },
            {
                [css.vehLitAudi]: props.theme === 'audi',
            },
            {
                [css.vehLitCV]: props.theme === 'chevrolet',
            },
            {
                [css.yearDivHonda]: props.theme === 'honda',
            },
            {
                [css.yearDivBuick]: props.theme === 'buick',
            },
            {
                [css.yearDivBMW]: props.theme === 'bmw',
            },
            {
                [css.yearDivFord]: props.theme === 'ford',
            },
        );
        let vehMake = vehArray.make;
        if (vehArray.makeCode === '2I'){
            vehMake = 'Scion';
        }
        vehicleInfoArea = <div className={menuBtnContentsStyles3}>
            <VehicleModelImages
                year={vehArray.year}
                make={vehArray.make}
                model={vehArray.model}
                type='thumb'
                className={vehImgCss}
                Itype={props?.Itype}
            />
            <div className={css.vehicleData}>
                <div className={makeDiv}>{vehMake} {vehArray.model}</div>
                <div className={yearDiv}>{yearStyleVin}</div>
            </div>
        </div>;
    }

    return (
        <div >
            <div className={css.menu}>
                <div className={logoArea}>
                    <Logo specData={props.specData} theme={props.theme} menuLogo/>
                </div>
                <JSXIf Condition={!showProfile}>
                    <MenuBackBtn click={props.back} theme={props.theme}/>
                </JSXIf>

                <JSXIf Condition={showProfile}>
                    {!hideMenuBtn ? <label className={css.menuBtn}>
                        <span id='menu' className={menuClassName}>
                            <Button
                                id='menuBtn'
                                onClick={menuOpenHandler}
                                type='contained'
                                variant='menuBtn'
                                tooltip={strings.MenuTitle}
                            >
                                <div className={menuBtnContentsStyles2}>
                                    <div className={css.menuIcon}>
                                        <IconDashMenu />
                                    </div>
                                    <div className={css.menuLit}>
                                        {strings.Menu}
                                    </div>
                                </div>
                            </Button>
                        </span>
                    </label> : null}
                </JSXIf>
                <div className={dealerNameClassName}>
                    {dealerNameArea}
                </div>
                <JSXIf Condition={showProfile}>
                    {!hideProfile ? <label className={css.profileBtn}>
                        <span className={profileClassName}>
                            <Button
                                id='profileBtn'
                                onClick={profileOpenHandler}
                                type='contained'
                                variant='menuBtn'
                                tooltip={strings.ProfileTitle}
                                disabled={props.employeeFlag ?? true}
                            >
                                <div id='profile' className={menuBtnContentsStyles}>
                                    <div className={css.profileIcon}>
                                        <IconProfile />
                                    </div>
                                    <div className={css.profileLit}>
                                        {strings.Profile}
                                    </div>
                                </div>
                            </Button>
                        </span>
                    </label> : null}
                </JSXIf>
                <JSXIf Condition={showProfile}>
                    {!hideVehicle ? <label className={css.vehBtn}>
                        <span className={vehClassName}>
                            <Button
                                id='vehBtn'
                                onClick={vehicleOpenHandler}
                                type='contained'
                                variant='menuBtn'
                            >
                                {vehicleInfoArea}
                            </Button>
                            <div className={vehIconClassName}>
                                <IconRDropDownArrow />
                            </div>
                        </span>
                    </label>: null}
                </JSXIf>
            </div>
        </div>
    );
};

export default MenuCustAcct;
